export const RESET = 'reset'
export const SELECT = 'select'
export const DROPDOWN_KEYS_WITH_ALL_CHILDREN_IN_URL = ['publicationDate']
